import SpriteSymbol from "../../../../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close",
  "use": "close-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 40 40\" id=\"close\"><path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M9.198 30.457a.75.75 0 1 0 1.061 1.06L20.478 21.3l10.197 10.197a.75.75 0 1 0 1.06-1.06L21.538 20.237l10.2-10.199a.75.75 0 1 0-1.061-1.06l-10.2 10.199L10.283 8.982a.75.75 0 1 0-1.06 1.06l10.195 10.196L9.198 30.457Z\" clip-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol